import React from "react";
import Loader from "components/Loader";
import OutlinedButton from "components/common/Button/OutlinedButton";
import { Input } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { t } from "i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import axiosInstance from "utils/axios";
import { formatMessage } from "utils/utility";

const VerifyEmail = ({ forgetPassword }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [timer, setTimer] = React.useState(30);
  const [inputVales, setInputValues] = React.useState({
    code: "",
    error: "",
    success: "",
    loading: false,
  });

  const { dir } = useAppSelector(getSettings);

  React.useEffect(() => {
    let timerVar = setInterval(() => {
      if (timer > 0) setTimer(timer - 1);
      else {
        clearInterval(timerVar);
      }
    }, 1000);
    return () => {
      clearInterval(timerVar);
    };
  }, [timer]);

  function handleSubmit() {
    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post(
        `users/${forgetPassword ? "forget-password-verify-otp" : "verify-otp"}`,
        {
          otp: inputVales.code,
          email: sessionStorage.getItem("email"),
        }
      )
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 200) {
          setInputValues({
            ...inputVales,
            error: "",
            loading: false,
            success: "",
          });
          sessionStorage.setItem("otp", inputVales.code);
          navigate(
            forgetPassword ? "/user-auth/new-password" : "/user-auth/add-key"
          );
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.message),
            loading: false,
            success: "",
          });
        }
      })
      .catch((err) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(err.message ?? err?.response?.data?.message ?? "someThingWentWrong"),
          loading: false,
          success: "",
        });
      });
  }

  function handleResendCode() {
    if (timer > 0) return;
    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post(
        `users/${forgetPassword ? "forget-password-resend-otp" : "resend-otp"}`,
        {
          email: sessionStorage.getItem("email"),
        }
      )
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 200) {
          setInputValues({
            ...inputVales,
            error: "",
            success: formatMessage(data.message),
            loading: false,
          });
          setTimer(30);
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.message),
            loading: false,
            success: "",
          });
        }
      })
      .catch((err) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(err.message ?? err?.response?.data?.message ?? "someThingWentWrong"),
          loading: false,
          success: "",
        });
      });
  }

  return (
    <>
      <Loader open={inputVales.loading} position="portal" />
      <div className="flex flex-col max-w-sm w-full px-6 md:px-0" dir={dir}>
        <div className="flex flex-col gap-4 mb-6">
          <p className="text-base text-gray-700 w-full text-center mb-6">
            {/* Check&nbsp;
            {sessionStorage.getItem("email")
              ? sessionStorage.getItem("email")
              : state?.email ?? "email"}&nbsp;
            for code */}
            {t("otpPageCheckForCode")}
          </p>
          {inputVales.error && (
            <p className="text-red-500 text-xs italic">
              {inputVales.error ?? t("someThingWentWrong")}
            </p>
          )}
          {inputVales.success && (
            <p className="text-green-500 text-xs italic">
              {inputVales.success ?? "Code sent successfully!"}
            </p>
          )}
          <Input
            id="verfiy-email"
            type="number"
            placeholder="XXX-XXX"
            value={inputVales.code}
            onChange={(e) => {
              const regex = /^\d{0,6}$/;
              if (regex.test(e.target.value))
                setInputValues({ ...inputVales, code: e.target.value });
            }}
            className="text-lg py-1"
          />
        </div>
        <div className="flex flex-col gap-3 items-center justify-center w-full">
          <OutlinedButton onClick={handleSubmit} disabled={inputVales.code.length < 6} className="disabled:opacity-50">
            {t("otpPageVerifyButon")}
          </OutlinedButton>
          <button
            className={`text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm disabled:opacity-50 ${
              timer > 0 ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={handleResendCode}
            disabled={timer > 0}
          >
            {t("otpPageSendAgainText")} {timer} {t("otpPageSecondsCountText")}
          </button>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
